import { http } from '../axios';
import { selectionlistConfig } from '../../config';
import { SpocContextChangeResponse } from '../../store/api';
import { SpocRequiredFor } from '../../shared/common/CheckRequiredSpoc/CheckRequiredSpoc';

export const fetchSelectionListRequiredSpoc = (type: SpocRequiredFor, listId: string) => {
    return http
        .get<SpocContextChangeResponse>(selectionlistConfig().endpointRequiredSpoc, {
            pathParams: { listId },
            errorCodesToSkip: [404]
        })
        .then(res => res.data);
};
